import { gql } from '@parkchirp/api-client';

export const LIST_SURCHARGE_FEES = gql`
  query listSurchargeFees(
    $facilityId: String!,
    $vehicleTypeId: Int!,
    $parkingType: SurchargeAssignmentType!
  ) {
    listSurchargeFees(
      facilityId: $facilityId,
      vehicleTypeId: $vehicleTypeId
      parkingType: $parkingType
    ) {
      data {
        id
        name
      }
    }
  }
`;
